/* eslint-disable camelcase */
export default class IntermediariesProductsTable {
  constructor(el) {
    this.$el = $(el);
    this.$content = this.$el.find(
      '.gg-intermediaries-products-table__content',
    );
    this.$noResults = this.$el.find(
      '.gg-intermediaries-products-table__no-results',
    );
    this.$sortSelect = this.$el.find(
      '.gg-intermediaries-products-table__sort',
    );

    // Filter elements
    this.$clearFiltersBtn = this.$el.find('.gg-filter-controls__clear-btn');
    this.$filterProductType = this.$el.find(
      '.gg-intermediaries-products-table__filter--product-type',
    );
    this.$filterRateType = this.$el.find(
      '.gg-intermediaries-products-table__filter--rate-type',
    );
    this.$loading = this.$el.find(
      '.gg-intermediaries-products-table__loading',
    );
    this.columnConfig = this.$content.data('column-config') || {};
    this.selectedProductTypes = this.$content.data('selected-product-types') || [];
    // Default sort
    this.currentSort = 'rate-low';
    this.isLoading = false;

    // Dropdown filters state
    this.dropdownFilters = {
      product_type: '',
      rate_type: '',
    };
    this.hasActiveDropdownFilters = false;
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Listen for sort change event
    $(document).on('intermediaryProductsSortChanged', (_e, value, _label) => {
      this.currentSort = value || 'rate-low';
      this.applyAllFilters();
    });

    // Listen for filter change events
    $(document).on('intermediaryProductsFilterChanged', (_e, _value, _label) => {
      this.collectDropdownFilters();
      this.applyAllFilters();
    });

    // Clear filters button
    this.$clearFiltersBtn.on('click', () => {
      this.clearAllFilters();
    });
  }

  // Collect current dropdown filter values from UI
  collectDropdownFilters() {
    this.dropdownFilters = {
      product_type:
        this.$filterProductType
          .find('.gg-select__option.active')
          .data('value') || '',
      rate_type:
        this.$filterRateType
          .find('.gg-select__option.active')
          .data('value') || '',
    };

    this.hasActiveDropdownFilters = Object.values(this.dropdownFilters).some(
      (val) => val !== '',
    );
  }

  // Apply all filters (dropdown + sort) and reload data
  applyAllFilters() {
    // Update button states
    this.updateClearFiltersButtonState();

    // Update URL with all params
    this.updateAllURLParams();

    // Reload all products
    this.loadProducts();
  }

  // Clear all dropdown filters
  clearAllFilters() {
    // Reset all dropdowns UI (only if they exist)
    if (
      this.$filterProductType.length &&
      this.$filterProductType.data('ggSelect')
    ) {
      this.$filterProductType.data('ggSelect').reset();
    }
    if (
      this.$filterRateType.length &&
      this.$filterRateType.data('ggSelect')
    ) {
      this.$filterRateType.data('ggSelect').reset();
    }
    if (
      this.$sortSelect.length &&
      this.$sortSelect.data('ggSelect')
    ) {
      this.$sortSelect.data('ggSelect').reset();
    }

    // Clear dropdown filters state
    this.dropdownFilters = {
      product_type: '',
      rate_type: '',
    };
    this.hasActiveDropdownFilters = false;

    // Reset sort to default
    this.currentSort = 'rate-low';

    // Apply all filters (sort reset to default)
    this.applyAllFilters();
  }

  // Update clear filters button enabled/disabled state
  updateClearFiltersButtonState() {
    const hasNonDefaultSort = this.currentSort && this.currentSort !== 'rate-low';
    const hasAnyFilters = this.hasActiveDropdownFilters || hasNonDefaultSort;
    this.$clearFiltersBtn.prop('disabled', !hasAnyFilters);
  }

  // Update URL with all params
  updateAllURLParams() {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Dropdown filter params
    if (this.dropdownFilters.product_type) {
      params.set('product_type', this.dropdownFilters.product_type);
    } else {
      params.delete('product_type');
    }

    if (this.dropdownFilters.rate_type) {
      params.set('rate_type', this.dropdownFilters.rate_type);
    } else {
      params.delete('rate_type');
    }

    // Sort param
    if (this.currentSort && this.currentSort !== 'rate-low') {
      params.set('sort_by', this.currentSort);
    } else {
      params.delete('sort_by');
    }

    // Update URL without page reload
    window.history.pushState({}, '', url.toString());
  }

  loadProducts() {
    if (this.isLoading) {
      return;
    }
    this.$loading.removeClass('hidden');
    this.isLoading = true;

    // Prepare AJAX data
    const ajaxData = {
      action: 'load_intermediary_products',
      sort_by: this.currentSort,
      column_config: this.columnConfig,
      selected_product_types: this.selectedProductTypes,
    };

    // Add dropdown filters
    const hasActiveDropdown = Object.values(this.dropdownFilters).some(
      (val) => val !== '',
    );
    if (hasActiveDropdown) {
      ajaxData.dropdown_filters = this.dropdownFilters;
    }

    $.ajax({
      type: 'POST',
      url: window.AJAX_URL,
      dataType: 'json',
      data: ajaxData,
      success: (response) => {
        if (response.success) {
          const hasResults = response.data.total > 0;

          if (hasResults) {
            // Show results, hide no results message
            this.$content.html(response.data.html);
            this.$content.show();
            this.$noResults.hide();

            // Lazy load images if available
            if (typeof window.lazyLoadImage !== 'undefined') {
              window.lazyLoadImage.lazyLoadImage();
            }
          } else {
            // No results found, show message
            this.$content.empty();
            this.$content.hide();
            this.$noResults.show();
          }
        } else {
          console.error(
            'Failed to load products:',
            response.data?.message,
          );
        }
        this.$loading.addClass('hidden');
      },
      error: (_jqXHR, textStatus, errorThrown) => {
        console.error('AJAX error:', textStatus, errorThrown);
        this.$loading.addClass('hidden');
      },
      complete: () => {
        this.isLoading = false;
        this.$loading.addClass('hidden');
      },
    });
  }
}

// Initialize on page load
if (typeof window.acf === 'undefined') {
  $(document).ready(() => {
    $('.gg-intermediaries-products-table').each((_index, el) => {
      new IntermediariesProductsTable(el).init();
    });
  });
} else {
  // eslint-disable-next-line
  acf.addAction(
    'render_block_preview/type=acf/gravity-intermediaries-products-table',
    ($el) => {
      $el.find('.gg-intermediaries-products-table').each((_index, el) => {
        new IntermediariesProductsTable(el).init();
      });
    },
  );
}
